
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const FloatingWhatsApp: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex items-center gap-3 pointer-events-auto">
      
      {/* Back To Top Floating Button */}
      <div 
        className={`transition-all duration-300 transform ${
          showScrollTop ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-90 pointer-events-none'
        }`}
      >
        <button
          onClick={scrollToTop}
          aria-label="Back to Top"
          className="relative group flex items-center justify-center w-13 h-13 sm:w-14 sm:h-14 bg-slate-900/90 hover:bg-indigo-600 text-white rounded-full shadow-[0_10px_25px_rgba(15,23,42,0.3)] hover:shadow-[0_10px_30px_rgba(99,102,241,0.5)] transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 border border-slate-700/80 hover:border-indigo-400/50 cursor-pointer backdrop-blur-md"
        >
          <ArrowUp size={22} className="group-hover:-translate-y-1 transition-transform duration-300" />

          {/* Tooltip */}
          <div className="absolute -top-12 left-1/2 -translate-x-1/2 bg-slate-900 border border-slate-700 text-white text-[11px] font-bold py-1.5 px-3.5 rounded-xl shadow-xl opacity-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap pointer-events-none flex items-center gap-1.5">
            <span>Back to Top</span>
            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-900 border-b border-r border-slate-700 transform rotate-45"></div>
          </div>
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <div className="relative group">
        {/* Pulsing background rings */}
        <div className="absolute inset-0 bg-emerald-500 rounded-full animate-ping opacity-25 group-hover:opacity-40 transition-opacity duration-300 pointer-events-none"></div>
        <div className="absolute inset-[-4px] bg-emerald-400 rounded-full animate-pulse opacity-20 group-hover:opacity-30 transition-opacity duration-300 pointer-events-none"></div>
        
        <a
          href="https://wa.me/923706487654"
          target="_blank"
          rel="noopener noreferrer"
          className="relative flex items-center justify-center w-13 h-13 sm:w-14 sm:h-14 bg-gradient-to-br from-emerald-400 to-emerald-600 hover:from-emerald-500 hover:to-emerald-700 text-white rounded-full shadow-[0_10px_25px_rgba(16,185,129,0.4)] transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 border border-white/20"
          aria-label="Contact on WhatsApp"
        >
          {/* Custom WhatsApp SVG Icon */}
          <svg 
            viewBox="0 0 24 24" 
            width="30" 
            height="30" 
            fill="currentColor" 
            className="group-hover:rotate-12 transition-transform duration-300 drop-shadow-xs"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .018 5.394 0 12.03c0 2.122.554 4.194 1.607 6.013L0 24l6.135-1.61a11.77 11.77 0 005.911 1.603h.005c6.634 0 12.032-5.396 12.035-12.032a11.763 11.763 0 00-3.489-8.492z"/>
          </svg>

          {/* Tooltip */}
          <div className="absolute -top-12 right-0 bg-slate-900 border border-slate-700 text-white text-[11px] font-bold py-1.5 px-3.5 rounded-xl shadow-xl opacity-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap pointer-events-none flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></div>
            <span>Chat on WhatsApp</span>
            <div className="absolute -bottom-1 right-5 w-2 h-2 bg-slate-900 border-b border-r border-slate-700 transform rotate-45"></div>
          </div>
        </a>
      </div>

    </div>
  );
};

export default FloatingWhatsApp;

